import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";
import { hasWindow } from "@utils/general";

import {
    PureAemComponent,
    registerComponent,
} from "@components/pureAemComponent";

import "./breadcrumb.scss";

class Breadcrumb extends PureAemComponent {
    activeElement: HTMLElement | null;
    mql: MediaQueryList;

    constructor(element: HTMLElement) {
        super(element);
        this.activeElement = this.element.querySelector("li:nth-last-child(2)");

        this.init();

        this.mql = window.matchMedia("(orientation: portrait)");

        this.mql.addEventListener("change", () => {
            this.scrollToBreadcrumbEnd();
        });
    }

    init() {
        this.checkForPdp();
        this.scrollToBreadcrumbEnd();
    }

    checkForPdp() {
        if (isPageTemplate(PageTemplates.PDP)) {
            this.element?.lastElementChild?.classList.add("d-none");
            this.element?.lastElementChild?.classList.add("d-md-flex");
        }
    }

    scrollToBreadcrumbEnd() {
        if (this.element && this.activeElement) {
            this.element.scrollLeft = this.activeElement.offsetLeft;
        }
    }
}

const InitBreadcrumb = () => {
    hasWindow() && registerComponent(".breadcrumb", Breadcrumb);
};

export { InitBreadcrumb };
